import React from 'react';
import { Globe, Zap, Smartphone, Database, Palette, TrendingUp } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const Capabilities = () => {
  const capabilities = [
    {
      icon: Globe,
      title: 'Web App Development',
      description: 'Build scalable, modern web applications with cutting-edge technologies and best practices.',
      projects: '10+ projects'
    },
    {
      icon: Zap,
      title: 'AI-Powered Automation',
      description: 'Integrate intelligent automation and AI features to enhance your product capabilities.',
      projects: '8+ projects'
    },
    {
      icon: Smartphone,
      title: 'Mobile App Prototypes',
      description: 'Create stunning mobile experiences with responsive design and native-like performance.',
      projects: '6+ projects'
    },
    {
      icon: Database,
      title: 'API Development',
      description: 'Design and build robust APIs with proper documentation and security measures.',
      projects: '12+ projects'
    },
    {
      icon: Palette,
      title: 'UI/UX Design',
      description: 'Craft beautiful, intuitive interfaces that users love and convert effectively.',
      projects: '15+ projects'
    },
    {
      icon: TrendingUp,
      title: 'Startup Launch Consulting',
      description: 'Get strategic guidance on product development, tech stack, and go-to-market strategy.',
      projects: '5+ clients'
    }
  ];

  return (
    <section id="capabilities" className="py-24 px-6 relative bg-gradient-to-b from-gray-900 to-black">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-white/60 font-semibold text-sm uppercase tracking-wide">Capabilities</span>
          <h2 className="text-4xl md:text-5xl font-extrabold mt-4 mb-4 text-white">
            What We Do?
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">Comprehensive solutions for your product development needs</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {capabilities.map((capability, index) => {
            const Icon = capability.icon;
            return (
              <Card
                key={index}
                className="bg-white/5 border-white/10 hover:border-white/30 transition-all duration-300 hover:transform hover:-translate-y-3 group cursor-pointer backdrop-blur-sm"
              >
                <CardContent className="p-6">
                  <div className="w-14 h-14 rounded-xl bg-white/10 flex items-center justify-center mb-4 group-hover:bg-white/20 transition-all duration-300">
                    <Icon className="w-7 h-7 text-white" />
                  </div>
                  <h3 className="text-xl font-bold mb-2 text-white group-hover:text-gray-200 transition-colors duration-300">
                    {capability.title}
                  </h3>
                  <p className="text-gray-400 text-sm mb-4 leading-relaxed">
                    {capability.description}
                  </p>
                  <div className="text-white/60 text-xs font-semibold">
                    {capability.projects}
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Capabilities;